<template>
  <div class="b-content">
    <loading :active.sync="loader" :is-full-page="true"></loading>

    <div class="b-table">
      <div class="b-table--header">
        <div class="b-table--info">
          <div class="b-table--info--item">
            <span>5</span>
            <span>Оценка (1...5)</span>
          </div>
          <div class="b-table--info--item">
            <span>
              <img src="dist/assets/img/language.svg" alt="Комментарий">
            </span>
            <span>Комментарий</span>
          </div>
          <div class="b-table--info--item">
            <span>
              <img src="dist/assets/img/launch-47.svg" alt="Рецензия">
            </span>
            <span>Рецензия</span>
          </div>
        </div>
        <div class="b-table--right">
          <div class="b-table--critic" v-for="(item, index) in critics" :key="index">
            <div class="b-table--critic--name">{{ item.critic }}</div>
            <div class="b-table--tooltip--critic">
              <img :src="$helperImagePath(item.photo,'critics')" :alt="item.critic">
              <span class="title">{{ item.critic }}</span>
              <template v-if="has(item, 'where')">
                <p>{{ item.where }}</p>
              </template>
            </div>
          </div>
          <div class="b-table--critic average">
            <div class="b-table--critic--name">Средняя оценка</div>
          </div>
        </div>
      </div>
      <div class="b-table--movie" v-for="(item, index) in _movies" :key="index">
        <div class="b-table--movie--title">
          <div class="b-table--movie--name" @click="_handleClickOpenMovie(item.movie)">
            <span>{{ item.movie }}</span>
            <small>{{ item.director }}</small>
          </div>

          <div class="b-table--tooltip--movie">
            <div class="left" v-if="item.photo">
              <template v-if="item.photo">
                <img
                  @error="_handleImageError"
                  :src="$helperImagePath(item.photo, 'movies')"
                  :alt="item.movie"
                >
              </template>
            </div>
            <div class="left" v-else style="background: white">
              <template>
                <img :src="`dist/assets/img/movies/no_poster.png`" :alt="item.movie">
              </template>
            </div>
            <div class="right">
              <span>{{ item.movie }}</span>
              <template v-if="(has(item, 'director'))">
                <small>{{ item.director }}</small>
              </template>
              <template v-if="(has(item, 'short_description'))">
                <p>{{ item.short_description }}</p>
              </template>
            </div>
          </div>
        </div>
        <div class="b-table--right">
          <template>
            <div v-for="(critic, index) in item.critics" :key=index
              :class="['b-table--movie--critic', `grade${critic.grade}`, (critic.comment) ? 'comment' : '']"
            >
              <template v-if="critic.review">
                <a
                  class="b-table--movie--critic--review"
                  :href="critic.review"
                  target="_blank"
                  title="Смотреть рецензию"
                ></a>
              </template>

              <span class="b-table--movie--critic--grade">{{critic.grade}}</span>
              <template v-if="critic.comment">
                <div class="b-table--movie--critic--comment"></div>
                <div class="b-table--tooltip--comment">
                  <div class="top">
                    <div class="left">
                      <span class="critic">{{ index }}</span>
                      <span class="movie">к фильму «{{ item.movie }}»</span>
                    </div>
                    <div class="right">
                      <span class="grade">{{ critic.grade }}</span>
                    </div>
                  </div>
                  <div class="tooltip-content">
                    <span class="title">Комментарий:</span>
                    <p>{{ critic.comment }}</p>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <div
            class="b-table--movie--average"
          >{{ item.average.toFixed(1).toString().replace('.',',') }}</div>
        </div>
      </div>
    </div>

    <vue-modal
      name="movie-modal"
      class="b-modal-movie"
      transitionName="slide-in-top"
      width="500"
      :hideCloseBtn="true"
      :on-close="_handleCloseMovieModal"
    >
      <a
        href="javascript:void(0)"
        @click="_handleClickCloseModal"
        class="b-modal-movie--close"
      >Закрыть</a>
      <template v-if="modal.movie">
        <div class="b-modal-movie--wrap">
          <div class="b-modal-movie--head">
            <div class="b-modal-movie-head--left" v-if="modal.movie.photo">
              <img
                @error="_handleImageError"
                :src="$helperImagePath(modal.movie.photo, 'movies')"
                :alt="modal.movie.movie"
              >
            </div>
            <div class="b-modal-movie-head--right">
              <div class="b-modal--movie--title">
                <span>{{ modal.movie.movie }}</span>
              </div>
              <div class="b-modal--movie--director">
                <span>{{ modal.movie.director }}</span>
              </div>

              <div class="b-modal--movie--date">
                <span class="title">Дата показа:</span>
                <span class="date">
                  {{ (has(modal.movie, 'world_premiere') && modal.movie.world_premiere)
                  ? $moment(modal.movie.world_premiere, 'DD.MM.YYYY').format('DD MMMM YYYY')
                  : 'Пока не известна' }}
                </span>
              </div>

              <div class="b-modal--movie--date">
                <span class="title">Дата выхода в РФ:</span>
                <span class="date">
                  {{ (has(modal.movie, 'rus_premiere') && modal.movie.rus_premiere)
                  ? ($moment(modal.movie.rus_premiere, 'DD.MM.YYYY').isValid()) ? $moment(modal.movie.rus_premiere, 'DD.MM.YYYY').format('DD MMMM YYYY') : modal.movie.rus_premiere
                  : 'Пока не известна' }}
                </span>
              </div>

              <div class="b-modal--movie--description">
                <p>{{ modal.movie.description }}</p>
              </div>
            </div>
          </div>
          <template v-if="(has(modal.movie, 'embed_youtube') && modal.movie['embed_youtube'])">
            <div class="b-modal--movie--embed" v-html="modal.movie['embed_youtube']"></div>
          </template>

          <template v-if="modal.movie.critics">
            <div class="b-modal--movie--review">
              <div class="b-modal--movie--review-table">
                <div class="b-modal--movie--review--item head">
                  <div class="b-modal-table--critic--name">
                    <span>Средняя оценка</span>
                  </div>
                  <div class="b-modal-table--critic--grade">
                    <span>{{ modal.movie.average.toFixed(1).toString().replace('.',',') }}</span>
                  </div>
                </div>
                <div
                  class="b-modal--movie--review--item"
                  v-for="(critic, index) in modal.movie.critics"
                  :key="index"
                >
                  <div class="b-modal-table--critic--name">
                    <span>{{ index }}</span>
                    <template v-if="critic.review">
                      <a
                        :href="critic.review"
                        target="_blank"
                        class="b-modal-table--movie--critic--review"
                      >
                        Ссылка на рецензию
                        <i class="icon--movie--critic--review"></i>
                      </a>
                    </template>
                  </div>
                  <div class="b-modal-table--critic--grade">
                    <span>{{ critic.grade }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </vue-modal>
  </div>
</template>

<script>
import * as d3 from "d3v4";
import { has } from "@utils";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

// const ID = "15IsH-8Gq5rAYqnk7nvUOc6uEG3xkRHRlpmXKpwnXVvg";
// const TABLE = `https://docs.google.com/spreadsheets/d/${ID}/export?format=csv&id=${ID}&gid={gid}`;
const TABLE = 'dist/assets/csv/{gid}.csv';
const GIDS = {
  critics: 'critics',
  movies: 'movies',
  grades: 'grades',
  reviews: 'reviews',
  comments: 'comments',
};

export default {
  components: { Loading },
  inject: ["$helperImagePath"],
  data() {
    return {
      has,
      loader: false,
      grades: [],
      movies: [],
      critics: [],
      comments: [],
      reviews: [],
      modal: {
        movie: null,
        value: false
      }
    };
  },
  computed: {
    criticNames() {
      return this.critics.map(e => e.critic);
    },
    _movies() {
      return this.movies.map(movie => {
        let grades = this.grades.find(item => item.movie === movie.movie),
          comments = this.comments.find(item => item.movie === movie.movie),
          reviews = this.reviews.find(item => item.movie === movie.movie);

        movie.average = 0;
        movie.critics = {};
        let countCriticAverages = 0;

        this.criticNames.forEach(critic => {
          let grade = has(grades, critic) ? grades[critic] || 0 : 0;
          movie.critics[critic] = {
            grade: grade ? grade : "",
            comment: has(comments, critic) ? comments[critic] : "",
            review: has(reviews, critic) ? reviews[critic] : ""
          };

          if (grade) countCriticAverages++;
          movie.average += parseInt(grade, 10);
        });

        movie.average = movie.average ? movie.average / countCriticAverages : 0;

        return movie;
      });
    }
  },
  created() {
    this.grades = this.$localStorage.get("grades", [], Array);
    this.movies = this.$localStorage.get("movies", [], Array);
    this.critics = this.$localStorage.get("critics", [], Array);
    this.reviews = this.$localStorage.get("reviews", [], Array);
    this.comments = this.$localStorage.get("comments", [], Array);
  },
  mounted() {
    this.loader = true;

    d3.queue()
      .defer(d3.csv, TABLE.replace("{gid}", GIDS["critics"]))
      .defer(d3.csv, TABLE.replace("{gid}", GIDS["movies"]))
      .defer(d3.csv, TABLE.replace("{gid}", GIDS["grades"]))
      .defer(d3.csv, TABLE.replace("{gid}", GIDS["comments"]))
      .defer(d3.csv, TABLE.replace("{gid}", GIDS["reviews"]))
      .await(this._handleLoadedSpreadsheet);
  },
  methods: {
    _handleImageError(event) {
      const { target } = event;
      target.src = `dist/assets/img/movies/no_poster.png`;
      target.style.background = "white";
    },
    _handleLoadedSpreadsheet(
      error,
      critics,
      movies,
      grades,
      comments,
      reviews
    ) {
      this.$localStorage.set("movies", JSON.stringify(movies));
      this.$localStorage.set("grades", JSON.stringify(grades));
      this.$localStorage.set("critics", JSON.stringify(critics));
      this.$localStorage.set("reviews", JSON.stringify(reviews));
      this.$localStorage.set("comments", JSON.stringify(comments));

      if (error) {
        throw new Error("Error loading google spreadsheets.");
      }

      this.loader = false;

      this.critics = critics.filter(critic => has(critic, "critic"));
      this.movies = movies.filter(movie => has(movie, "movie"));
      this.grades = grades.filter(grade => has(grade, "movie"));
      this.comments = comments.filter(comment => has(comment, "movie"));
      this.reviews = reviews.filter(review => has(review, "movie"));
    },
    _handleClickOpenMovie(item) {
      let movie = { ...this.movies.find(m => m.movie === item) };

      if (movie) {
        let grades = this.grades.find(item => item.movie === movie.movie),
          reviews = this.reviews.find(item => item.movie === movie.movie);

        movie.average = 0;
        movie.critics = {};
        let countCriticAverages = 0;

        this.criticNames.forEach(critic => {
          let grade = has(grades, critic) ? grades[critic] || 0 : 0;
          movie.critics[critic] = {
            grade: grade ? grade : "",
            review: has(reviews, critic) ? reviews[critic] : ""
          };

          if (grade) countCriticAverages++;
          movie.average += parseInt(grade);
        });

        movie.average = movie.average ? movie.average / countCriticAverages : 0;

        this.modal = { value: true, movie };
        this.$modals.show("movie-modal");
      } else throw new Error("Error find movie.");
    },
    _handleCloseMovieModal() {
      this.modal.movie = null;
    },
    _handleClickCloseModal() {
      this.$modals.hide("movie-modal");
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/home.vue